import React from 'react';
import { MessageCircle } from 'lucide-react';

/**
 * ChatToggleButton - Floating button to open the chat panel
 * Extracted from DesignPreviewPage.js
 */
const ChatToggleButton = ({ onClick, isOpen }) => {
  if (isOpen) return null;

  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 w-14 h-14 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 z-50"
      data-testid="chat-toggle-button"
    >
      <MessageCircle className="w-6 h-6" />
    </button>
  );
};

export default ChatToggleButton;
